module.exports = __webpack_public_path__ + "static/media/hero_image_back.dc43e092.png";